let BASE_URL = process.env.REACT_APP_BASE_URL ?? '';
if (!BASE_URL.endsWith('/api')) {
  BASE_URL += '/api';
}

// Configuration flags
export const config = {
  // Demo Generator Configuration
  // Set REACT_APP_ENABLE_DEMO_GENERATOR=true in environment variables to enable
  // Set REACT_APP_ENABLE_DEMO_GENERATOR=false or omit to disable (recommended for production)
  enableDemoGenerator: process.env.REACT_APP_ENABLE_DEMO_GENERATOR === 'true',
};

export const urls = {
  cfo: {
    activedisputes: `${BASE_URL}/disputes/activedisputes`,
    spendingbytopowners: `${BASE_URL}/reporting/users-spending-with-last-month`,
  },
  DevOps: {
    getFilterCloudAccounts: `${BASE_URL}/filters/filtergetcloudaccounts`,
    getFilterCloudAccountOwners: `${BASE_URL}/filters/filtergetcloudaccountowners`,
    getFilterDepartments: `${BASE_URL}/filters/filtergetdepartments`,
    getFilterSubscriptions: `${BASE_URL}/filters/filtergetsubscriptions`,
    getFilterSystems: `${BASE_URL}/filters/filtergetsystems`,
    getFilterUsers: `${BASE_URL}/users?view=light`,
    allresources: `${BASE_URL}/resources`,
    resourcesByUser: `${BASE_URL}/resources/byuser`,
    unassignedresources: `${BASE_URL}/assignments/unassignedresources`,
    systemlessresources: `${BASE_URL}/systems/systemlessresources`,
    resourcegroups: `${BASE_URL}/resource-groups/resourcegroups`,
    assignowner: `${BASE_URL}/assignments/assignowner`,
    allsystems: `${BASE_URL}/systems`,
    systemswithbudget: `${BASE_URL}/systems/systemswithbudget`,
    updateSystem: `${BASE_URL}/systems`,
    deleteSystem: `${BASE_URL}/systems`,
    createSystem: `${BASE_URL}/systems`,
    setSystemBudget: `${BASE_URL}/systems/setsystembudget`,
    systemBudgetPendingChange: `${BASE_URL}/systems/systembudgetpendingchange`,
    costsSummary: `${BASE_URL}/reporting/costssummary`,
    assignSystem: `${BASE_URL}/systems/assignsystem`,
    spendingByDepartments: `${BASE_URL}/reporting/spending-by-departments`,
    spendingBySystems: `${BASE_URL}/systems/spendingBySystems`,
    spendingByUsers: `${BASE_URL}/reporting/users-spending-with-last-month`,
    disputesList: `${BASE_URL}/disputes/disputeslist`,
    actionCenterDetails: `${BASE_URL}/action-center/actioncenterdetails`,
    getMessages: `${BASE_URL}/notifications/getmessages`,
    sendMessages: `${BASE_URL}/notifications/sendmessage`,
    markMessagesRead: `${BASE_URL}/notifications/markmessagesread`,
    getDepartmentSpending: `${BASE_URL}/reporting/spending-by-departments`,
    getCostPerDay: `${BASE_URL}/reporting/cost-per-day`,
    getCostPerDayDashboard: `${BASE_URL}/reporting/cost-per-day-dashboard`,
    top10systems: `${BASE_URL}/reporting/top10-systems`,
    top10users: `${BASE_URL}/reporting/top10-users`,
    top10departments: `${BASE_URL}/reporting/top10-departments`,
    top10resources: `${BASE_URL}/reporting/top10-resources`,
    recommendations: `${BASE_URL}/recommendations/recommendations`,
    getRecommendationsByResourceId: `${BASE_URL}/recommendations/recommendations/resource/:resourceId`,
    top10recommendations: `${BASE_URL}/reporting/top10-recommendations`,
    optimizationPotential: `${BASE_URL}/recommendations/optimizationpotential`,
    optimizationChartData: `${BASE_URL}/recommendations/optimization-chart-data`,
    top10unassignedresources: `${BASE_URL}/assignments/top10unassignedresources`,
    getOptimizationActionCenterV2: `${BASE_URL}/action-center/getoptimizationactioncenterv2`,
    getDashboardActionCenterV2: `${BASE_URL}/action-center/getdashboardactioncenterv2`,
    getBudgetActionCenterV2: `${BASE_URL}/action-center/getbudgetactioncenterv2`,
    getAllocationActionCenterV2: `${BASE_URL}/action-center/getallocationactioncenterv2`,
    getAttestationActionCenterV2: `${BASE_URL}/action-center/getattestationactioncenterv2`,
    getActionCenterItemText: `${BASE_URL}/action-center/item-text`,
    hideActionCenterItemText: `${BASE_URL}/action-center/item-text/hide`,
    getAttestationTable: `${BASE_URL}/attestations/attestationtable`,
    attestateResource: `${BASE_URL}/attestations/attestateresource`,
    attestateResources: `${BASE_URL}/attestations/attestateresources`,
    rejectResources: `${BASE_URL}/attestations/rejectresources`,
    deleteResource: `${BASE_URL}/resources/deleteresource`,
    confirmResourceDeletion: `${BASE_URL}/resources/confirmresourcedeletion`,
    confirmResourcesDeletion: `${BASE_URL}/resources/confirmresourcesdeletion`,
    getAttestationConfirmationTable: `${BASE_URL}/attestations/attestationconfirmationtable`,
    getDispute: `${BASE_URL}/disputes/getdispute/:id`,
    createDispute: `${BASE_URL}/disputes/createdispute`,
    createDisputeV1: `${BASE_URL}/disputes/createdisputev1`,
    createDisputeV2: `${BASE_URL}/disputes/createdisputev2`,
    deleteDispute: `${BASE_URL}/disputes/deletedispute`,
    getMaxDispute: `${BASE_URL}/disputes/getmaxdispute`,
    updateDispute: `${BASE_URL}/disputes/updatedispute`,
    getDisputesByResourceId: `${BASE_URL}/disputes/byresource/:resourceId`,
    getResourcesByDisputeId: `${BASE_URL}/disputes/getresources/:disputeId`,
    getConfig: `${BASE_URL}/config/getconfig`,
    currencies: `${BASE_URL}/config/currencies`,
    updateConfig: `${BASE_URL}/config/updateconfig`,
    getAttestationByUser: `${BASE_URL}/attestations/getattestationbyuser`,
    getAttestationBySystem: `${BASE_URL}/attestations/getattestationbysystem`,
    attestationData: `${BASE_URL}/attestations/data`,
    attestationChartsData: `${BASE_URL}/attestations/charts-data`,
    attestationStackedChartData: `${BASE_URL}/attestations/stacked-chart-data`,
    getDisputeUsers: `${BASE_URL}/disputes/getdisputeusers`,
    addDisputeUser: `${BASE_URL}/disputes/adddisputeuser`,
    getMyDisputeList: `${BASE_URL}/disputes/getmydisputeslist`,
    getResourcesCosts: `${BASE_URL}/reporting/resources-costs`,
    getResourcePopupDetails: `${BASE_URL}/resources/:id/popupdetails`,
    getResourceIdByIdentifier: `${BASE_URL}/resources/byidentifier/:identifier`,
    getCostsByResourceType: `${BASE_URL}/reporting/costs-by-resource-type`,
    getCostPerDayMonthly: `${BASE_URL}/reporting/cost-per-day-monthly`,
    getAvailableDisputeUsers: `${BASE_URL}/disputes/getavailabledisputeusers`,
    getDisputeUnreadSummary: `${BASE_URL}/disputes/unread-summary`,
    getUsersAll: `${BASE_URL}/users?view=full&type=all`,
    getUsersTech: `${BASE_URL}/users?view=light&type=tech`,
    getUsersBusiness: `${BASE_URL}/users?view=light&type=business`,
    getUsersFilter: `${BASE_URL}/users?view=light`,
    getDepartments: `${BASE_URL}/departments/getdepartments`,
    getAzureSettings: `${BASE_URL}/config/getAzureSettings`,
    aiEngineSettings: `${BASE_URL}/ai-recommendations/settings`,
    aiEngineRuns: `${BASE_URL}/ai-recommendations/runs`,
    aiEngineBatchRuns: `${BASE_URL}/ai-recommendations/batch-runs`,
    aiEngineBatchRun: (id: number) =>
      `${BASE_URL}/ai-recommendations/batch-runs/${id}`,
    aiEngineTriggerRun: `${BASE_URL}/ai-recommendations/run`,
    aiClaudeModels: `${BASE_URL}/ai/claude-models`,
    aiClaudeStatus: `${BASE_URL}/ai/claude-status`,
    aiClaudeTest: `${BASE_URL}/ai/claude-test`,
    aiClaudeAuthStart: `${BASE_URL}/ai/claude-auth/start`,
    aiClaudeAuthStatus: (sessionId: string) =>
      `${BASE_URL}/ai/claude-auth/status/${sessionId}`,
    aiClaudeAuthCode: `${BASE_URL}/ai/claude-auth/code`,
    agentSettings: `${BASE_URL}/agent/settings`,
    agentStatus: `${BASE_URL}/agent/status`,
    agentRuns: `${BASE_URL}/agent/runs`,
    agentBatchRuns: `${BASE_URL}/agent/batch-runs`,
    agentBatchRun: (id: number) => `${BASE_URL}/agent/batch-runs/${id}`,
    agentApprovals: `${BASE_URL}/agent/approvals`,
    agentApprovalRespond: (id: number) =>
      `${BASE_URL}/agent/approvals/${id}/respond`,
    agentOutreach: `${BASE_URL}/agent/outreach`,
    agentConversations: `${BASE_URL}/agent/conversations`,
    agentTools: `${BASE_URL}/agent/tools`,
    agentConsoleTurn: `${BASE_URL}/agent/console/turn`,
    agentTriggerRun: `${BASE_URL}/agent/run`,
    agentTestMessage: `${BASE_URL}/agent/test-message`,
    agentTestGraph: `${BASE_URL}/agent/test-graph`,
    agentOwnerDiscovery: `${BASE_URL}/agent/owner-discovery`,
    agentOwnerDiscoveryRun: `${BASE_URL}/agent/owner-discovery/run`,
    syncLogs: `${BASE_URL}/sync/logs`,
    syncLogById: (id: number) => `${BASE_URL}/sync/logs/${id}`,
    syncLogResync: (id: number) => `${BASE_URL}/sync/logs/${id}/resync`,
    syncLogResyncFailed: `${BASE_URL}/sync/logs/resync-failed`,
    syncCloudAccount: `${BASE_URL}/resource-costs/sync-cloud-account`,
    uploadPhoto: `${BASE_URL}/uploads/photo`,
    blobUrl: (blobName: string) =>
      `${BASE_URL}/uploads/blob-url/${encodeURIComponent(blobName)}`,
    getTimeMachineUtcNow: `${BASE_URL}/config/utcnow`,
    setTimeMachineUtcNow: `${BASE_URL}/config/timemachine/set`,
    clearTimeMachineUtcNow: `${BASE_URL}/config/timemachine/clear`,
    createUser: `${BASE_URL}/authorization/register`,
    updateUser: `${BASE_URL}/users/updateuser`,
    deleteUser: `${BASE_URL}/users/deleteuser`,
    updateUserPassword: `${BASE_URL}/users/`,
    deletePasswordHash: (userId: number) =>
      `${BASE_URL}/users/${userId}/delete-password-hash`,
    createDepartment: `${BASE_URL}/departments/createdepartment`,
    setDepartmentBudget: `${BASE_URL}/departments/setdepartmentbudget`,
    deleteDepartment: `${BASE_URL}/departments/deletedepartment`,
    updateDepartment: `${BASE_URL}/departments/updatedepartment`,
    deleteUserFromDispute: `${BASE_URL}/disputes/deleteuserfromdispute`,
    getNotifications: `${BASE_URL}/notifications/getnotifications`,
    updateNotification: `${BASE_URL}/notifications/updatenotification`,
    createNotification: `${BASE_URL}/notifications/createnotification`,
    getOnboardingSteps: `${BASE_URL}/config/getonboardingsteps`,
    getCloudAccounts: `${BASE_URL}/config/getcloudaccountsconfig`,
    getCloudProviders: `${BASE_URL}/config/getcloudproviders`,
    addCloudAccountsConfig: `${BASE_URL}/config/addcloudaccountconfig`,
    deleteCloudAccount: `${BASE_URL}/config/deletecloudaccount`,
    updateCloudAccountsConfig: `${BASE_URL}/config/updatecloudaccountconfig`,
    upsertCloudAccount: `${BASE_URL}/config/upsertCloudAccount`,
    getCloudAccountTechUsers: (id: number) =>
      `${BASE_URL}/config/cloudaccounts/${id}/techusers`,
    getAvailableCloudAccountTechUsers: (id: number) =>
      `${BASE_URL}/config/cloudaccounts/${id}/techusers/available`,
    addCloudAccountTechUser: (id: number) =>
      `${BASE_URL}/config/cloudaccounts/${id}/techusers`,
    deleteCloudAccountTechUser: (id: number, userId: number) =>
      `${BASE_URL}/config/cloudaccounts/${id}/techusers/${userId}`,
    rejectRecommendation: `${BASE_URL}/recommendations/recommendation/:id/reject`,
    implementRecommendation: `${BASE_URL}/recommendations/recommendation/:id/implement`,
    updateMessage: `${BASE_URL}/notifications/updatemessage`,
    getRecommendationDetails: `${BASE_URL}/recommendations/recommendationmodal`,
    getRGTags: `${BASE_URL}/resource-groups/resourcegroup/:id/tags`,
    getUserQrCode: `${BASE_URL}/users/getqrcode/:id`,
    setUser2FA: `${BASE_URL}/authorization/set2fa`,
    // Demo Generator Endpoints
    generatorStep: `${BASE_URL}/generator`,
    resetGenerator: `${BASE_URL}/generator/reset`,

    // BUDGETS
    getGlobalBudget: `${BASE_URL}/budgets/global`,
    updateGlobalBudget: `${BASE_URL}/budgets/updateglobalbudget`,
    usersbudgets: `${BASE_URL}/budgets/usersbudgets`,
    getUsersBudgets: `${BASE_URL}/budgets/usersbudgets`,
    // Budgets redesign (v2) – source of truth for yearly limits & currency
    getBudgetV2ById: (budgetId: number) => `${BASE_URL}/budgets/v2/${budgetId}`,
    getLatestBudgetV2ForScope: (params?: {
      departmentId?: number | null;
      systemId?: number | null;
      year?: number;
    }) => {
      const p = params ?? {};
      const qs = new URLSearchParams();
      if (p.departmentId != null)
        qs.set('departmentId', String(p.departmentId));
      if (p.systemId != null) qs.set('systemId', String(p.systemId));
      if (p.year != null) qs.set('year', String(p.year));
      const q = qs.toString();
      return `${BASE_URL}/budgets/v2/latest${q ? `?${q}` : ''}`;
    },
    getLatestBudgetsV2Bulk: `${BASE_URL}/budgets/v2/latest/bulk`,
    getPendingBudgetChangesV2: `${BASE_URL}/budgets/v2/pending`,
    decideBudgetChangeV2: (budgetId: number) =>
      `${BASE_URL}/budgets/v2/${budgetId}/decision`,
    getAnnualBudgetConsumptionV2: (params?: {
      departmentId?: number | null;
      systemId?: number | null;
      year?: number;
      currency?: string;
    }) => {
      const p = params ?? {};
      const qs = new URLSearchParams();
      if (p.departmentId != null)
        qs.set('departmentId', String(p.departmentId));
      if (p.systemId != null) qs.set('systemId', String(p.systemId));
      if (p.year != null) qs.set('year', String(p.year));
      if (p.currency != null) qs.set('currency', String(p.currency));
      const q = qs.toString();
      return `${BASE_URL}/budgets/v2/consumption/annual${q ? `?${q}` : ''}`;
    },
    getMonthlyBudgetConsumptionV2: (params?: {
      departmentId?: number | null;
      systemId?: number | null;
      year?: number;
      currency?: string;
    }) => {
      const p = params ?? {};
      const qs = new URLSearchParams();
      if (p.departmentId != null)
        qs.set('departmentId', String(p.departmentId));
      if (p.systemId != null) qs.set('systemId', String(p.systemId));
      if (p.year != null) qs.set('year', String(p.year));
      if (p.currency != null) qs.set('currency', String(p.currency));
      const q = qs.toString();
      return `${BASE_URL}/budgets/v2/consumption/monthly${q ? `?${q}` : ''}`;
    },

    bulkSaveDepartmentBudgets: `${BASE_URL}/departments/budget/bulk`,
    bulkSaveSystemBudgets: `${BASE_URL}/budgets/system/bulk`,

    getDepartmentsBudgetsSum: `${BASE_URL}/budgets/departments/sum`,
    createGlobalBudgetChangeRequest: `${BASE_URL}/budgets/global/change-request`,
    createDepartmentBudgetChangeRequest: `${BASE_URL}/budgets/department/change-request`,
    createSystemBudgetChangeRequest: `${BASE_URL}/budgets/system/change-request`,
    createDepartmentBudgetRequest: `${BASE_URL}/budgets/department/request`,
    createSystemBudgetRequest: `${BASE_URL}/budgets/system/request`,
    approveBudgetChangeRequest: `${BASE_URL}/budgets/change-request/approve`,
    processPendingBudgetChanges: `${BASE_URL}/budgets/process-pending-changes`,
    getUserRoles: `${BASE_URL}/users/roles`,
    // extra permissions
    isDepartmentOwner: (userId: number) =>
      `${BASE_URL}/users/${userId}/isDepartmentOwner`,
    isSystemOwner: (userId: number) =>
      `${BASE_URL}/users/${userId}/isSystemOwner`,
    isResourceOwner: (userId: number) =>
      `${BASE_URL}/users/${userId}/isResourceOwner`,
    isCloudAccountOwner: (userId: number) =>
      `${BASE_URL}/users/${userId}/isCloudAccountOwner`,
  },
  User: {
    authenticate: `${BASE_URL}/authorization/authenticate`,
    check2fa: `${BASE_URL}/authorization/check2fa`,
    enroll2faStart: `${BASE_URL}/authorization/enroll2fa/start`,
    enroll2faConfirm: `${BASE_URL}/authorization/enroll2fa/confirm`,
    current: `${BASE_URL}/users/current`,
  },
  Auth: {
    config: `${BASE_URL}/auth/config`,
    session: `${BASE_URL}/auth/session`,
    logout: `${BASE_URL}/auth/logout`,
    me: `${BASE_URL}/auth/me`,
  },
};

export const ROUTES = {
  ADMINISTRATION: '/admin',
  AI: '/ai',
  ALLOCATION: '/allocation',
  ATTESTATION: '/attestation',
  AUTH_CALLBACK: '/auth/callback',
  BUDGETS: '/budgets',
  DASHBOARD: '/dashboard',
  DISPUTES: '/disputes',
  HOME: '/',
  LOGIN: '/login',
  OPTIMIZATION: '/optimization',
  REPORTING: '/reporting',
};
